import React from 'react';
import { useGetProductsStatus } from '../apiHooks/productsStatus.hook';
import { ProductsStatusKey } from '../@types/productsStatus';

export const useProductStatus = (productType: ProductsStatusKey, enabled = true) => {
  const { productsStatus } = useGetProductsStatus(enabled);
  return React.useMemo(() => {
    if (!productsStatus || !productsStatus[productType]) return null;
    return productsStatus[productType];
  }, [productType, productsStatus]);
};
